import API_BASE_URL from '../Config';

const ROL_API = `${API_BASE_URL}/roles`;

/**
 * Obtiene todos los roles.
 */
export const getRoles = async () => {
    const response = await fetch(ROL_API, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
    });
    if (!response.ok) throw new Error(`Error ${response.status}: Error al obtener los roles`);
    return await response.json();
};

/**
 * Obtiene un rol por su ID.
 */
export const getRolById = async (id) => {
    const response = await fetch(`${ROL_API}/${id}`, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
    });
    if (!response.ok) throw new Error(`Error ${response.status}: Error al obtener el rol`);
    return await response.json();
};

/**
 * Crea un nuevo rol.
 */
export const createRol = async (rolData) => {
    const response = await fetch(ROL_API, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(rolData)
    });
    if (!response.ok) throw new Error(`Error ${response.status}: Error al crear el rol`);
    return await response.json();
};

/**
 * Actualiza un rol existente.
 */
export const updateRol = async (id, rolData) => {
    const response = await fetch(`${ROL_API}/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(rolData)
    });
    if (!response.ok) throw new Error(`Error ${response.status}: Error al actualizar el rol`);
    return await response.json();
};

/**
 * Elimina un rol.
 */
export const deleteRol = async (id) => {
    const response = await fetch(`${ROL_API}/${id}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
    });
    if (!response.ok) throw new Error(`Error ${response.status}: Error al eliminar el rol`);
    return true;
};
